import compact from "lodash/compact";
import head from "lodash/head";
import { RowType } from "PFApp/booking/types/row";
import { Icon } from "PFComponents/icon";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { validateCategoryIcon } from "PFModules/admin/booking/categories/booking_categories.utils";
import { Color } from "PFTypes";

const ICONS_BY_TYPE = {
  role: "role",
  engagement: "engagement",
  audit_role: "role-audit",
  audit_engagement: "engagement-audit",
  profile: "profile",
  hiddenCategory: "locked"
};

type EntityIconProps = {
  templateId?: number | null;
  type: string;
  bookingCategoryIds?: number[];
  color?: Color;
};

export const EntityIcon = ({
  templateId,
  type,
  bookingCategoryIds,
  color = "paletteBlue0"
}: EntityIconProps) => {
  const {
    data: { templates }
  } = useMyAccountInfo();
  const { getBookingCategory } = useBookingCategories();

  if (type === RowType.Category) {
    const bookingCategory = head(
      compact(bookingCategoryIds?.map((categoryId) => getBookingCategory(categoryId)))
    );
    const iconName = validateCategoryIcon(bookingCategory?.icon);
    return iconName && <Icon name={iconName} size="md" color="paletteBlue0" />;
  }

  const templateKey = ![RowType.Profile as string, "hiddenCategory"].includes(type)
    ? templates?.find(({ id }) => id === templateId)?.key
    : null;

  const iconName = ICONS_BY_TYPE[templateKey || type];

  return iconName && <Icon name={iconName} size="md" color={color} />;
};
